import gql from 'graphql-tag';

export const requestAccessQuery = gql`
  query RequestAccess($input: RequestAccessInput!) {
    requestAccess(input: $input)
  }
`;